var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.984 0a24 24 0 1016.991 7.034A24.087 24.087 0 0023.984 0zm0 9.296a8.559 8.559 0 014.743 1.441 8.595 8.595 0 013.622 8.748 8.555 8.555 0 01-2.341 4.363 8.519 8.519 0 01-13.105-10.763 8.52 8.52 0 017.08-3.788zm0 33.313a18.559 18.559 0 01-14.19-6.605 10.803 10.803 0 019.546-5.792c.231.002.46.038.68.106a12.08 12.08 0 007.926 0c.22-.068.45-.104.68-.106a10.804 10.804 0 019.546 5.792 18.559 18.559 0 01-14.188 6.606z",
    fill: "#707070"
  })));
};
export default __webpack_public_path__ + "static/media/DefaultAvatar.5fd6e724.svg";
export { SvgDefaultAvatar as ReactComponent };